import { onFirstNavigationEnter, canViewDemo } from '../middleware/middleware';

import AvatarSelect from '../../components/game/pages/AvatarSelect';
import AvatarSelectOutro from '../../components/game/pages/AvatarSelectOutro';
import BackstorySelect from '../../components/game/pages/BackstorySelect';
import ChallengeIntro from '../../components/game/pages/ChallengeIntro';
import ChallengeOutro from '../../components/game/pages/ChallengeOutro';
import GameEnd from '../../components/game/pages/GameEnd';
import GameError from '../../components/game/pages/GameError';
import GameIntro from '../../components/game/pages/GameIntro';
import GameOutro from '../../components/game/pages/GameOutro';
import Dashboard from '../../components/game/pages/Dashboard';
import GameStart from '../../components/game/pages/GameStart';
import PlayerReportDownloader from '../../components/game/pages/PlayerReportDownloader';
import GameHub from '../../components/game/pages/GameHub';
import IndividualDecision from '../../components/game/pages/IndividualDecision';
import Results from '../../components/game/pages/Results';
import RoleSelect from '../../components/game/pages/RoleSelect';
import RoleSelectOutro from '../../components/game/pages/RoleSelectOutro';
import TeamDecision from '../../components/game/pages/TeamDecision';
import WaitForTeam from '../../components/game/pages/WaitForTeam';
import SocketIOContainer from '../../components/networking/SocketIOContainer';

export default [
  {
    path: '/hub',
    component: GameHub,
    beforeEnter: canViewDemo,
    meta: {
      hideProgressBar: true, isGameRoute: true, useSignInForNavbar: true
    }
  },
  {
    path: '/downloadplayerreport/:reportFileName/:blobUrl',
    component: PlayerReportDownloader,
    beforeEnter: canViewDemo,
    props: true,
    meta: {
      hideProgressBar: true, isGameRoute: true, useSignInForNavbar: true
    }
  },
  { path: '/demo', component: GameStart, beforeEnter: canViewDemo, meta: { hideProgressBar: true, useSignInForNavbar: true } },
  {
    path: '/groups/:groupId',
    component: SocketIOContainer,
    props: true,
    children: [
      { path: '/groups/:groupId', component: GameStart, meta: { hideProgressBar: true, showHubButton: true, ignoreAssetPreloadWatcher: true } },
      { path: '/groups/:groupId/intro', component: GameIntro, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/backstory-select', component: BackstorySelect, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/avatar-select', component: AvatarSelect, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/avatar-select-outro', component: AvatarSelectOutro, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/role-select', component: RoleSelect, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/role-select-outro', component: RoleSelectOutro, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/wait-for-team', component: WaitForTeam, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/challenge/intro', component: ChallengeIntro, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/challenge/dashboard', component: Dashboard, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/challenge/major-decision', component: TeamDecision, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/challenge/minor-decision', component: IndividualDecision, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/challenge/results', component: Results, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/challenge/outro', component: ChallengeOutro, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/outro', component: GameOutro, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/end', component: GameEnd, beforeEnter: onFirstNavigationEnter('/groups/:groupId') },
      { path: '/groups/:groupId/error', component: GameError, beforeEnter: onFirstNavigationEnter('/groups/:groupId') }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/game/routes.js